// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gjeb","select":"styles_select__ri37U"};